var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCEuro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9167 11.4439C21.4792 10.1573 19.581 9.375 17.5 9.375C13.0127 9.375 9.375 13.0127 9.375 17.5C9.375 21.9873 13.0127 25.625 17.5 25.625C19.581 25.625 21.4792 24.8427 22.9167 23.5561M7.75 19.9375H15.875M7.75 15.0625H15.875M33.75 17.5C33.75 26.4746 26.4746 33.75 17.5 33.75C8.52537 33.75 1.25 26.4746 1.25 17.5C1.25 8.52537 8.52537 1.25 17.5 1.25C26.4746 1.25 33.75 8.52537 33.75 17.5Z",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCEuro);
export default __webpack_public_path__ + "static/media/c_euro.dac7d9e9a453ef1d2b6a399d6228be47.svg";
export { ForwardRef as ReactComponent };